import useRanking from "./hooks/useRanking";
import RankingView from "./view";

export default function Ranking({ groupId }) {
    const state = useRanking(groupId);
    return <RankingView {...state} />;
}
